export default __webpack_public_path__ + "static/media/IMG24.cea7cc31.jpg";